module.exports = __webpack_public_path__ + "img/id-badge-primary.ca863e80.svg";